export default __webpack_public_path__ + "static/media/js.3475505c.png";